import {styled} from "@reside/ui";

export const DocumentPreviewBarContainer = styled.div`
  position: sticky;
  top: -16px;
  z-index: 2;
  background-color: white;
  padding: 8px 0;

  button {
    max-height: fit-content;
  }
`;

export const ErrorLoadingPDFContainer = styled.div`
  padding: 20px;
  max-width: 80%;
  margin: 24px auto;
  text-align: center;

  p {
    margin-bottom: 16px;
  }
`;
